// Легкий pub-sub без Redux/Context — єдина точка сповіщення "токен читача
// протух" для всіх місць, що шлють X-Reader-Token (App.js, CabinetPage.js,
// BookFullView.js). Модульні функції (getBookmarks і т.п. у CabinetPage.js)
// не мають доступу до React-колбеків напряму, тому підписка одна на весь
// застосунок — реєструється один раз у корені App.js.
let readerSessionExpiredHandler = null;

export function onReaderSessionExpired(fn) {
  readerSessionExpiredHandler = fn;
}

// Обгортка над fetch() для ендпоінтів, захищених X-Reader-Token
// (cabinet.php, bookmarks.php, order.php, fulltext.php?action=ticket).
// При 401 (reader_token протух, TTL 8 год) сповіщає підписника — той
// розлогинює читача і показує на екрані входу повідомлення про це.
export function readerFetch(url, token, options = {}) {
  return fetch(url, {
    ...options,
    headers: { ...(options.headers || {}), 'X-Reader-Token': token || '' },
  }).then(r => {
    if (r.status === 401 && readerSessionExpiredHandler) readerSessionExpiredHandler();
    return r;
  });
}
